import theme from "../../../../js/shared/new-theme";
import { fontSize12 } from "@maxmilhas/hangar-components-atomic/public/styles/components/quarks/layout";

export const defaultStyle = `
    margin: 0;
    width: 40px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;

    .switch-form-label {
        padding-bottom: 5px;
        margin-top: 3px;
        margin-left: 10px;
        color: ${theme.palette.gray[500].value};
        font-size: ${fontSize12};
        flex-shrink: 0;
        font-weight: 500;
        cursor: pointer;
    }

    .switch-form {
        visibility: hidden;
        position: absolute;
        margin-left: -9999px;
    }

    .switch-form + label {
        display: block;
        position: relative;
        cursor: pointer;
        outline: none;
        user-select: none;
    }

    .switch-form--flat + label {
        padding: 2px;
        width: 40px;
        height: 23px;
        background-color: ${theme.palette.common.white};
        border: 1px solid;
        border-radius: 60px;
        transition: background 0.2s;
        flex-shrink: 0;
    }
    .switch-form--flat + label:before,
    .switch-form--flat + label:after {
        display: block;
        position: absolute;
        content: "";
    }
    .switch-form--flat + label:before {
        top: 2px;
        left: 2px;
        bottom: 2px;
        right: 2px;
        background-color: ${theme.palette.common.white};
        border-radius: 60px;
        transition: background 0.4s;
    }
    .switch-form--flat + label:after {
        top: 3px;
        left: 3px;
        bottom: 3px;
        width: 16px;
        background-color: ${theme.palette.primary[700].value};
        border-radius: 52px;
        transition: margin 0.4s, background 0.4s;
    }

    &.switch-form-checked {
        .switch-form--flat + label {
            background-color: ${theme.palette.primary[700].value};
            border-color: ${theme.palette.primary[700].value};
        }
        .switch-form--flat + label:before {
            background-color: ${theme.palette.primary[700].value};
        }
        .switch-form--flat + label:after {
            margin-left: 15px;
            background-color: ${theme.palette.common.white};
        }
    }
`;
